import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Header from '../components/Header'
import Navbar from '../components/Navbar/navbar'
import Footer from '../components/footer/footer'
import CookiesNotification from '../components/Notifications/cookiesNotification'
import '../styles/main.scss'



const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Gorka Muñoz - Diseñador y desarrollador web"
      meta={[
        { name: 'description', content: 'Diseño y desarrollo web desde Bilbao. Encuentra información sobre diseño UI/UX, programación, libros y mucho más.' },
        { name: 'keywords', content: 'diseñador web, bilbao, bizkaia, programador web' },
        {'charSet': 'utf-8'},

      ]}
      links={[
        {
          rel: 'stylesheet',
          href: 'https://fonts.googleapis.com/css?family=Merriweather:300,300i,400,400i,700'
        },
        {
          rel: 'stylesheet',
          href: 'https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,400i,700,700i'
        },

        {
          rel: 'stylesheet',
          href: ' https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css'
        }

      ]}
  
    />

  <Navbar></Navbar>
 
      {children()}
  <Footer/>
  <CookiesNotification/>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
    
}
require("prismjs/themes/prism-okaidia.css");
export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js